import { Link } from "react-router-dom";
import styled from "styled-components";

export const NftCardWrapper = styled(Link)`
  background: ${(props) => props.theme.bgrColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 16px;
  width: 299px;
  margin: 20px auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 420px;
`;

export const ImgWrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  height: 315px;
  position: relative;
  & img {
    border-radius: 6px;
    object-fit: contain;
    width: 100%;
    height: auto;
    max-height: 100%;
    max-width: 100%;
  }
`;

export const NftCardInfo = styled.div`
  margin: 10px 0 5px;
  position: relative;
`;

export const CardInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
`;

export const NftTitle = styled.div`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DotsButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  & span {
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(props) => props.theme.textColor};
    margin-left: 4px;
  }
`;

export const NftPrice = styled.div`
  display: flex;
  flex-direction: column;
  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.theme.textColor};
    margin: 5px 0;
  }
  & h5 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
  }
`;

export const NftCardLogo = styled.img`
  max-width: 30px;
  align-self: flex-end;
`;

export const BuyButton = styled.button`
  width: 100%;
  background: #0088cc;
  border-radius: 36px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  padding: 0;
  font-size: 18px;
  height: ${(props) => (props.showButton ? `40px` : `0`)};
  transition: 0.2s;
  color: #ffffff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 0 solid transparent;
  margin-top: ${(props) => (props.showButton ? `10px` : `0`)};
  transition: 0.2s;
  &:hover {
    background: transparent;
    color: #0088cc;
    border: 1px solid #0088cc;
  }
`;

export const LikeWrapper = styled.div`
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  right: 10px;
  top: 10px;
  background: rgba(140, 140, 140, 0.27);
  backdrop-filter: blur(20px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
